module.exports = __webpack_public_path__ + "img/stwo.533ca10b.png";